export const applyInitialStyles = () => {
  const urlSearch = new URLSearchParams(window.location.search);
  const hideUIParam = urlSearch.get('pdHideUI');
  const hideUI = hideUIParam === 'true' || hideUIParam === '1';

  if (hideUI) {
    document.documentElement.classList.remove('hide-ui-initial');
    document.body.classList.add('hide-ui');
  }
};
